import React from 'react';
import { Button } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

/**
 * Direct Google OAuth login component that bypasses Google Identity Services
 * and uses direct OAuth2 redirect flow for better compatibility with modern browsers
 */
const DirectGoogleLogin = ({ onSuccess, onError }) => {
  const handleDirectLogin = async () => {
    try {
      console.log('[DIRECT_OAUTH] Starting direct Google OAuth flow');
      
      // Get the Google Client ID from backend
      const configResponse = await fetch('/api/config', {
        credentials: 'include'
      });
      
      if (!configResponse.ok) {
        throw new Error('Failed to get Google Client ID');
      }
      
      const config = await configResponse.json();
      const clientId = config.googleClientId;
      
      console.log('[DIRECT_OAUTH] Got client ID:', clientId ? `${clientId.substring(0, 10)}...` : 'undefined');
      
      if (!clientId) {
        throw new Error('Google Client ID not available');
      }
      
      // Build OAuth URL - use localhost:3000 to match Google Cloud Console config
      const redirectUri = 'http://localhost:3000/auth/callback';
      const scope = 'openid email profile';
      const responseType = 'code';
      const state = Math.random().toString(36).substring(2, 15);
      
      // Store state in sessionStorage for verification
      sessionStorage.setItem('oauth_state', state);
      
      const oauthUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth');
      oauthUrl.searchParams.set('client_id', clientId);
      oauthUrl.searchParams.set('redirect_uri', redirectUri);
      oauthUrl.searchParams.set('scope', scope);
      oauthUrl.searchParams.set('response_type', responseType);
      oauthUrl.searchParams.set('state', state);
      oauthUrl.searchParams.set('access_type', 'offline');
      oauthUrl.searchParams.set('prompt', 'consent');
      
      console.log('[DIRECT_OAUTH] Redirecting to:', oauthUrl.toString());
      
      // Redirect to Google OAuth
      window.location.href = oauthUrl.toString();
      
    } catch (error) {
      console.error('[DIRECT_OAUTH] Error:', error);
      if (onError) {
        onError(error);
      }
    }
  };

  return (
    <Button
      variant="outlined"
      startIcon={<GoogleIcon />}
      onClick={handleDirectLogin}
      sx={{
        textTransform: 'none',
        borderColor: '#dadce0',
        color: '#3c4043',
        '&:hover': {
          backgroundColor: '#f8f9fa',
          borderColor: '#dadce0',
        },
      }}
    >
      Sign in with Google (Direct)
    </Button>
  );
};

export default DirectGoogleLogin;
